import appConfig from '../../../app-config'

/**
 * VideoQuiz Showcase is type:premium in Mongo but must not count as paid premium
 * for District Certified, Collections prioritization, or premium labels (ASM-628).
 * Uses existing REACT_APP_VIDEO_QUIZ_COLLECTION_ID via appConfig.
 */
export const isNonPaidPremiumId = (id) => {
  if (id == null || id === '') {
    return false
  }
  const videoQuizCollectionId =
    appConfig.videoQuizDefaultCollection?.collectionId
  if (!videoQuizCollectionId) {
    return false
  }
  return `${id}` === `${videoQuizCollectionId}`
}

export default {
  isNonPaidPremiumId,
}
